import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faImage} from '@fortawesome/fontawesome-free-solid';
import './file.scss';

export class File extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChange(event);
    }

    render() {
        const name = this.props.name;
        const accept = this.props.accept || '*';
        const placeholder = this.props.placeholder;
        var fileName = null;

        if(this.refs.file) {
            if(this.refs.file.files && this.refs.file.files.length > 0) {
                fileName = this.refs.file.files[0].name;
            }
        }

        return (
            <div className="chooseFile">
                <div className="labelText">
                    {!fileName && <FontAwesomeIcon icon={faImage} />} 
                    {!fileName && ` ${placeholder}`}
                    <span className="choosenFileName">{fileName}</span>
                </div>
                <input type="file" name={name} ref="file" onChange={this.handleChange} accept={accept}/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/File.jsx